import React, {useContext, useEffect, useRef, useState} from 'react';
import {Layout, Modal, Row} from "antd";
// import styles from "../Groups/Groups.module.scss";
import style from "./Conferences.module.scss";
import styles from "./Conferences.module.scss";
import {useTranslation} from "react-i18next";
import useFetch, {CachePolicies} from "use-http";
import {JanusAPIEndpoint} from "../../../service/janus.service";
import * as Auth from "../../../service/auth.service";
import {getToken, getUserData} from "../../../service/auth.service";
import {useNavigate} from "react-router-dom";
import SkeletonCard from "../Groups/SkeletonCard";
import CardContainer from "../../Group/CardGroup/CardContainer";
import {HomeContext} from "../../Home/Home.context";
import {getAuthorization, getPathWss} from "../../../service/util.service";
import {requestIcon} from "../Request/request.utils.props";
import ConferenceCard from "../../Group/CardGroup/ConferenceCard";
import axios from "axios";
import {attachAudioBridge} from "../../videoCall/VideoConference/utils/AudioBridge";
import NoData from 'src/components/shared/NoDataDisplay/NoData';
import {getJanusServerURL} from "../../../service/config.service";

const { Content } = Layout;

let janus: any;

const Conference = (props: any) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const homeContext: any = useContext(HomeContext);
    const [confRoomList, setConfRoomList] = useState<any>([]);
    const [loaded, setLoaded] = useState<boolean>(false);
    const [userData, setUserData] = useState(getUserData());
    const [confEvent, setConfEvent] = useState<any>();

    const isDestroy = useRef<boolean>(false);

    const noDataHeaderText = t("No Conference available");
    const nodatatext = t("When have any conferences, they'll appear on your profile");


    const { confirm, error } = Modal;

    const confRoomAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + JanusAPIEndpoint.confRoom,
        {
            headers: { Authorization: `Bearer ${getToken()}` },
            cachePolicy: CachePolicies.NO_CACHE
        }
    );


    const fetchConfRoomList = async () => {
        try {
            let res = await confRoomAPI.get();
            console.log("[GetConfRoom]", res);
            setConfRoomList(res);
            //TODO next
            if (res?.length > 0) {
                getRoomActive(res);
            }
            setLoaded(true);
        } catch (e) {
            console.error("[GetConfRoomListError]", e);
            setLoaded(true);
        }
    };


    const janusRoomStatus = async (groupId: string, status: any) => {
        return await axios.post(
            window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + JanusAPIEndpoint.VideoRoom + `/updateStatus`,
            { groupID: groupId, isActive: status },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: getAuthorization(),
                },
            }
        );
    };

    const getRoomActive = async (confRoom: any) => {
        let server: any = null;
        try {
            server = await getJanusServerURL();
        } catch (err) {
            return;
        }
        //@ts-ignore
        const audioOpaqueId = "audiobridge-" + window.Janus.randomString(12);

        //@ts-ignore
        window.Janus.init({
            debug: "all", callback: function () {
                //@ts-ignore
                if (!window.Janus.isWebrtcSupported()) {
                    console.log("No WebRTC support... ");
                    return;
                }

                //@ts-ignore
                janus = new Janus(
                    {
                        server: server,
                        success: function () {

                            attachAudioBridge(janus, audioOpaqueId, null, null, null, null, true,
                                (mixerPlugin: any, eventType: any, data: any) => {

                                    if (eventType === "success") {
                                        if (confRoom.length <= 7) {
                                            confRoom.forEach((conf: any) => {
                                                let updatedAt = new Date(conf?.confRoom?.updatedAt);
                                                let now = new Date();
                                                // @ts-ignore
                                                let diff = now - updatedAt;
                                                if (diff <= 10000) return;

                                                console.log("Conf", conf?.confRoom?.confRoomID, diff)
                                                let listParticipants = {
                                                    request: "listparticipants",
                                                    room: conf?.confRoom?.confRoomID,
                                                };

                                                mixerPlugin.send({
                                                    message: listParticipants,
                                                    success: async function (result: any) {
                                                        console.log("Result", result);
                                                        if (result?.participants?.length === 0 || result?.error_code === 426) {
                                                            await janusRoomStatus(conf?.confRoom?.groupID, false)
                                                            // @ts-ignore
                                                            setConfRoomList((oldGroup: any[]) => oldGroup.filter((item: { confRoom: { groupID: any; }; }) => item?.confRoom?.groupID !== conf?.confRoom?.groupID));
                                                        } else {
                                                            await janusRoomStatus(conf?.confRoom?.groupID, true)
                                                        }
                                                    },
                                                    error: function (error: any) {
                                                        janus.destroy();
                                                    }
                                                });
                                            });
                                            janus.destroy();
                                        } else {
                                            let roomList = {
                                                request: "list"
                                            };

                                            mixerPlugin.send({
                                                message: roomList,
                                                success: function (result: any) {

                                                    confRoom.forEach((con: {
                                                        confRoom: {
                                                            groupID: string;
                                                            confRoomID: any;
                                                        };
                                                    }) => {
                                                        let conDetails = result?.list?.find((r: any) => r.room === con?.confRoom?.confRoomID);
                                                        if (conDetails?.num_participants === 0 || conDetails?.error_code === 426) {
                                                            console.log("Result", conDetails);
                                                            janusRoomStatus(con?.confRoom?.groupID, false)
                                                            // @ts-ignore
                                                            setConfRoomList((oldGroup: any[]) => oldGroup.filter((item: { confRoom: { groupID: any; }; }) => item?.confRoom?.groupID !== con?.confRoom?.groupID));
                                                        } else {
                                                            janusRoomStatus(con?.confRoom?.groupID, true)
                                                        }
                                                    })

                                                    janus.destroy();
                                                },
                                                error: function (error: any) {
                                                    // janus.destroy();
                                                    janus.destroy();
                                                }
                                            });

                                        }
                                    }
                                }
                            );
                        },
                        error: function (error: any) {
                            //@ts-ignore
                            window.Janus.error(error);
                            janus.destroy();
                        },
                        destroyed: function () {
                            console.log("janus Destroyed")
                        }
                    });
            }
        });
    }

    useEffect(() => {
        fetchConfRoomList();

        return () => {
            confRoomAPI.abort();
            try {
                janus.destroy()
            } catch (e) {

            }
        };
    }, []);

    useEffect(() => {
        if (!userData) return;

        let pathUrl = window.__RUNTIME_CONFIG__.REACT_APP_GENERAL_CENTER_WS;
        pathUrl = getPathWss(pathUrl);

        const token = Auth.getToken();
        const userId = Auth.getUserData().id
        const reconnectDuration = 10000;

        const socketURL = `${pathUrl}/?type=act-conf&userID=${userId}&token=${token}`;
        isDestroy.current = false;

        console.log("[act-conf]", socketURL);

        let socket: any;

        function connect() {
            socket = new WebSocket(socketURL);
            socket.onopen = () => {
                console.log(":: active conference open");
            };
            socket.onclose = (e: any) => {
                console.log(":: active conference closed");
                if (isDestroy.current) return;
                setTimeout(() => {
                    connect();
                }, reconnectDuration);
            };
            socket.onmessage = (msg: any) => {
                console.log("raw data", msg);
                const msgData = JSON.parse(msg?.data);
                console.log("msg data", msgData);
                setConfEvent(msgData);
            };
        }

        //TODO next
        // connect();

        return () => {
            try {
                socket?.close();
            } catch (e) {
                console.log("socket close", e)
            }
            isDestroy.current = true;
            console.log(":: active conference is closed now");
        };
    }, [userData])

    useEffect(() => {
        if (!confEvent) return;
        console.log("confEvent", confEvent);

        const eventType = confEvent?.body?.messageType;
        switch (eventType) {
            case "active-room":
                console.log("active-room");
                // const oldList = confRoomList;
                let group = confEvent?.body?.data?.group;
                // oldList.push({ group })
                setConfRoomList([...confRoomList.filter((item: any) => item.group.id !== group.id), { group: group }]);
                break;
            case "inactive-room":
                setConfRoomList([...confRoomList.filter((item: any) => item.group.id !== confEvent?.body?.data?.group?.id)]);
                break;
        }
    }, [confEvent])

    useEffect(() => {
        console.log("confRoomList", confRoomList);
    }, [confRoomList])

    // @ts-ignore
    // @ts-ignore
    return (
        <Layout>
            <Content
                id="allGroupContainer"
                style={{
                    width: "100%",
                    height: "calc(100vh - 50px)",
                    overflow: "auto",
                    alignSelf: "center",
                }}
                className={styles.allGroupContainer}
            >
                <Row
                    style={{
                        // fontSize: "20px",
                        minHeight: "calc(100vh - 50px)",
                        backgroundColor: "#F8F8F8",
                        color: "#000000",
                    }}
                >
                    <div
                        className={styles.boxContent}
                        style={{
                            marginLeft: props.page === "chat" ? "252px" : "0px",
                            width: props.page === "chat" ? "100%" : "100%",
                        }}
                    >
                        <div
                            className={styles.contentContainer}
                        >
                            <div
                                className={styles.headerGroups}
                            >
                                {/*<div style={{ fontSize: "1rem", fontWeight: 600 }}>*/}
                                {/*    {t("Conferences")}*/}
                                {/*</div>*/}
                                <div className={styles.searchContainer}>
                                    <div
                                        className={style.searchIcon}
                                        style={{ backgroundImage: `url(${requestIcon.searchIcon})` }}
                                    />
                                    <input
                                        type="text"
                                        className={style.searchInput}
                                        placeholder={t("Search")}
                                    />
                                </div>
                                {/*<div style={{ paddingLeft: 29, width: "100%" }}>*/}
                                {/*    <Input*/}
                                {/*        size="large"*/}
                                {/*        placeholder="Search"*/}
                                {/*        // prefix={<SearchOutlined />}*/}
                                {/*        // onChange={(event) => {*/}
                                {/*        //     searchGroup(event);*/}
                                {/*        // }}*/}
                                {/*        style={{ height: 40 }}*/}
                                {/*    />*/}
                                {/*</div>*/}
                                {/*<div style={{ paddingLeft: 37 }}>*/}
                                {/*    <Button className={styles.createGroupButton}*/}
                                {/*            onClick={handleLive}*/}
                                {/*    >*/}
                                {/*        {t("Live")}*/}
                                {/*    </Button>*/}
                                {/*</div>*/}
                            </div>
                            <div style={{ paddingTop: 50 }}>
                                {/*<InfiniteScroll*/}
                                {/*    dataLength={confRoomList == null ? 0 : confRoomList?.length}*/}
                                {/*    next={fetchNextGroup}*/}
                                {/*    hasMore={hasMoreGroup}*/}
                                {/*    scrollableTarget={"allGroupContainer"}*/}
                                {/*    loader={*/}
                                {/*        !hasMoreGroup ? null : (*/}
                                {/*            <div className={styles.allCardGroup}>*/}
                                {/*                <SkeletonCard />*/}
                                {/*            </div>*/}
                                {/*        )*/}
                                {/*    }*/}
                                {/*>*/}
                                <CardContainer
                                    header={t("Conference" + (confRoomList?.length && confRoomList?.length > 0 ? "s" : "s")) + ` (${confRoomList?.length || 0})`}
                                // number={confRoomList?.length}
                                >
                                {(!loaded) ? (
                                    <div className={styles.allCardGroup}>
                                                <SkeletonCard />
                                            </div>
                                    ) :( <div className={styles.cardGroup}>
                                    {confRoomList?.map((conf: any) => {
                                        return (
                                           <ConferenceCard
                                           key={conf?.group?.id}
                                           id={conf?.group?.id}
                                           coverImgURL={conf?.group?.coverImgURL}
                                           name={conf?.group?.name}
                                       />
                                       )
                                   })}
                               </div>)}
                                </CardContainer>
                                {(confRoomList?.length === 0 && confRoomList !== null && loaded) && (
                                    <NoData header={noDataHeaderText} detail={nodatatext} />
                                )}
                                {/*</InfiniteScroll>*/}
                            </div>
                        </div>
                    </div>
                </Row>
            </Content>
        </Layout>
    )
}

export default Conference;